import { jwtDecode, type JwtPayload } from "jwt-decode";
import { useAuth } from "react-oidc-context";
import { Navigate, Outlet } from "react-router";
import { roles, routes, type Role } from "~/lib/constants";

type Props = {
  allowedRoles: Role[];
};

export const RoleGuard = ({ allowedRoles }: Props) => {
  const { user } = useAuth();
  const userToken = user?.id_token;
  let userRole: Role = roles.none;

  if (userToken) {
    try {
      userRole = jwtDecode<JwtPayload & { role?: Role }>(userToken).role || roles.none;
    } catch (error) {
      console.error("Error decoding token:", error);
      userRole = roles.none;
    }
  }

  const isAllowed = allowedRoles.includes(userRole);
  if (!isAllowed) {
    return <Navigate to={routes.dashboard.taskManager} replace />;
  }

  return <Outlet />;
};
